jQuery(document).ready(function($) {
    const swiper = new Swiper('.product-swiper', {
        loop: false,
        spaceBetween: 24,
        navigation: {
            nextEl: '.product-swiper-wrap .swiper-button-next',
            prevEl: '.product-swiper-wrap .swiper-button-prev',
        },
        pagination: {
            el: '.product-swiper-wrap .swiper-pagination',
            type: 'progressbar',
        },
        slidesPerView: 1.2, // Mobile default
        breakpoints: {
            576: {
                slidesPerView: 2.5
            },
            768: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 5
            }
        }
    });
});
